// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgba(0, 0, 0, 0.4);
  height: 400px;
  flex-direction: column;
  margin: 0 auto;
}

ion-icon {
  font-size: 55px;
  margin-bottom: 10px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/general components/deleted-content/deleted-content.component.scss","webpack://./src/components/general%20components/deleted-content/deleted-content.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;ACCJ;;ADEA;EACI,eAAA;EACA,8BAAA;ACCJ","sourcesContent":[".content {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: rgb(0, 0, 0, 0.4);\n    height: 400px;\n    flex-direction: column;\n    margin: 0 auto;\n}\n  \nion-icon {\n    font-size: 55px;\n    margin-bottom: 10px !important;\n}",".content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: rgba(0, 0, 0, 0.4);\n  height: 400px;\n  flex-direction: column;\n  margin: 0 auto;\n}\n\nion-icon {\n  font-size: 55px;\n  margin-bottom: 10px !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
